(function () {
    var $doc = $(document);
    var SR = window.SR || {};
    SR.App = $(window);

    // 调试
    SR.debug = {};
    
    // 生命周期
    SR.lifecycle = {
        launch: function() {
            SR.App.trigger('onLaunch');
            SR.performance.onLaunch = Date.now() - SR.performance.tick;
        },
        mount: function() { 
            SR.App.trigger('onMount');
            SR.performance.onMount = Date.now() - SR.performance.tick;
        },
        show: function() {
            SR.state.isDebug && console.log('onShow');
            SR.App.trigger('onShow');
        },
        hide: function() {
            SR.state.isDebug && console.log('onHide');
            SR.App.trigger('onHide');
        },
        unload: function() {
            // SR.App.on('unload', handle);
        }
    };

    // 组件定义
    SR.component = {
        extend: function(componentName, handle) {
            if (this[componentName] === undefined) {
                if (componentName.indexOf('.') !== -1) {
                    // 支持二级命名空间扩展
                    var nameSpaces = componentName.split('.');
                    if (nameSpaces.length > 2) {
                        console.log('SR.component expands 2 level at most');
                        return;
                    }
                    if (this[nameSpaces[0]]) {
                        this[nameSpaces[0]].prototype[nameSpaces[1]] = handle;
                    } else {
                        console.log(nameSpaces[0] + ' is undefined');
                    }
                } else {
                    this[componentName] = handle;
                }
            } else {
                console.warn(componentName + ' already exists');
            }
        }
    }

    SR.modules = {
        extend: SR.component.extend
    };

    SR.middleware = {
        beforeRenderAnswer: function(data) {
            return data;
        }
    };

    function addVisibilityChangeEvent() {
        var hidden;
        var visibilityChange;

        if (typeof document.hidden !== 'undefined') {
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }

        SR.data.events = {
            visibilityChangeEvent: visibilityChange
        };

        $doc.on(visibilityChange, function() {
            var status = document[hidden] ? 'hidden' : 'active';
            if (status === 'active') {
                SR.lifecycle.show();
            } else {
                SR.lifecycle.hide();
            }
        });
    }
    addVisibilityChangeEvent();

    window.SR = SR;
}());